"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentFilterBlockSchema = void 0;
const zod_1 = require("zod");
// Схема для IContentFilterBlock
exports.contentFilterBlockSchema = zod_1.z.object({
  order: zod_1.z.number(),
  id: zod_1.z.number(),
  code: zod_1.z.string(),
  type: zod_1.z.enum(['subject', 'language', 'contentType', 'userServiceCategory', 'meetingAccess']),
  title: zod_1.z.string(),
  item: zod_1.z.any(),
  // Subject | Language | ContentTypeEnum | UserServiceCategory | MeetingAccessEnum
  total_count: zod_1.z.number(),
  new_count: zod_1.z.number().optional(),
  is_visible: zod_1.z.boolean().optional(),
  is_favorite: zod_1.z.boolean().optional(),
  is_favoritable: zod_1.z.boolean().optional(),
  is_highlighted: zod_1.z.boolean().optional(),
  notification: zod_1.z.number().optional()
});
